/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	DateTime: `scalar.DateTime` as const,
	AccountStatus: "enum" as const,
	UserProgress: "enum" as const,
	BillingTier: "enum" as const,
	BillingPaymentTerm: "enum" as const,
	RoleEnum: "enum" as const,
	CertificateOrientation: "enum" as const,
	OrganizationStatus: "enum" as const,
	ScormModuleStatus: "enum" as const,
	ScormCompletionStatus: "enum" as const,
	ScormSuccessStatus: "enum" as const,
	ModuleLockReason: "enum" as const,
	SessionStatus: "enum" as const,
	SessionProgressionMode: "enum" as const,
	TrialReviewStatus: "enum" as const,
	SsoProviderKind: "enum" as const,
	ConsentStatus: "enum" as const,
	Query:{
		getRole:{

		},
		getPermission:{

		},
		getMail:{

		},
		learnerCounters:{

		},
		learnerCountersByOrganization:{

		},
		billingEstimate:{

		},
		billingHistory:{

		},
		getUser:{

		},
		getExistingUserEmails:{

		},
		getFilteredUsers:{
			findManyUserWithFiltersInput:"FindManyUserWithFiltersInput"
		},
		group:{

		},
		scormModule:{

		},
		getMyScormTracking:{

		},
		getScormTrackings:{
			input:"FindManyScormTrackingWithFiltersInput"
		},
		getScormTrackingStats:{
			input:"ScormTrackingStatsInput"
		},
		session:{

		},
		userSessions:{

		},
		downloadFile:{

		},
		publishBasicSubscription:{

		},
		organizationMembers:{

		}
	},
	FindManyUserWithFiltersInput:{
		orderBy:"UserOrderByInput",
		filterBy:"UserFilterByInput"
	},
	UserOrderByInput:{
		email:"OrderByEnum",
		firstName:"OrderByEnum",
		lastName:"OrderByEnum",
		lastConnectionAt:"OrderByEnum",
		role:"OrderByEnum"
	},
	OrderByEnum: "enum" as const,
	UserFilterByInput:{
		progress:"UserProgress"
	},
	FindManyScormTrackingWithFiltersInput:{
		orderBy:"ScormTrackingOrderByInput",
		filterBy:"ScormTrackingFilterByInput"
	},
	ScormTrackingOrderByInput:{
		userEmail:"OrderByEnum",
		userFirstName:"OrderByEnum",
		userLastName:"OrderByEnum",
		completionStatus:"OrderByEnum",
		successStatus:"OrderByEnum",
		scoreRaw:"OrderByEnum",
		completedAt:"OrderByEnum"
	},
	ScormTrackingFilterByInput:{
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus"
	},
	ScormTrackingStatsInput:{
		filterBy:"ScormStatsScopeInput"
	},
	ScormStatsScopeInput:{

	},
	Mutation:{
		updateAppConfig:{
			input:"UpdateAppConfigInput"
		},
		updateBillingProfile:{
			input:"UpdateBillingProfileInput"
		},
		changeBillingPlan:{
			input:"ChangeBillingPlanInput"
		},
		login:{

		},
		requestMagicLink:{

		},
		loginWithMagicLink:{

		},
		askForResetPassword:{

		},
		reSendEmailValidation:{

		},
		resetPassword:{

		},
		verifyEmail:{

		},
		finishRegister:{

		},
		uniqueAuthFromSso:{

		},
		impersonateUser:{

		},
		createUser:{
			createUserInput:"CreateUserInput"
		},
		importUsers:{
			users:"ImportUserInput"
		},
		updateUser:{
			updateUserInput:"UpdateUserInput"
		},
		deleteUser:{

		},
		createGroup:{
			input:"CreateGroupInput"
		},
		updateGroup:{
			input:"UpdateGroupInput"
		},
		deleteGroup:{

		},
		addUsersToGroup:{

		},
		removeUsersFromGroup:{

		},
		setSsoEnabled:{

		},
		upsertSsoProvider:{
			input:"UpsertSsoProviderInput"
		},
		deleteSsoProvider:{
			kind:"SsoProviderKind"
		},
		deleteScormModule:{

		},
		upsertScormTracking:{
			input:"UpsertScormTrackingInput"
		},
		createSession:{
			input:"CreateSessionInput"
		},
		updateSession:{
			input:"UpdateSessionInput"
		},
		deleteSession:{

		},
		requestTrialOrganization:{
			input:"RequestTrialInput"
		},
		confirmTrialOrganization:{

		},
		approveTrialRequest:{

		},
		rejectTrialRequest:{

		},
		updateCertificateTemplate:{
			input:"UpdateCertificateTemplateInput"
		},
		deleteFile:{

		},
		uploadPreSignedUrl:{

		},
		confirmUpload:{

		},
		createOrganization:{
			input:"CreateOrganizationInput"
		},
		setOrganizationStatus:{
			status:"OrganizationStatus"
		},
		updateOrganization:{
			input:"UpdateOrganizationInput"
		},
		deleteOrganization:{

		},
		inviteOrgMember:{
			input:"InviteOrgMemberInput"
		},
		removeOrgMember:{

		},
		updateReminderSettings:{
			input:"UpdateReminderSettingsInput"
		},
		sendReminderTest:{
			input:"UpdateReminderSettingsInput"
		}
	},
	UpdateAppConfigInput:{

	},
	UpdateBillingProfileInput:{

	},
	ChangeBillingPlanInput:{
		tier:"BillingTier",
		paymentTerm:"BillingPaymentTerm"
	},
	EError: "enum" as const,
	CreateUserInput:{

	},
	ImportUserInput:{

	},
	UpdateUserInput:{

	},
	CreateGroupInput:{

	},
	UpdateGroupInput:{

	},
	UpsertSsoProviderInput:{
		kind:"SsoProviderKind"
	},
	UpsertScormTrackingInput:{
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus"
	},
	CreateSessionInput:{
		modules:"SessionModuleInput",
		progressionMode:"SessionProgressionMode"
	},
	SessionModuleInput:{

	},
	UpdateSessionInput:{
		status:"SessionStatus",
		progressionMode:"SessionProgressionMode",
		modules:"SessionModuleInput"
	},
	RequestTrialInput:{

	},
	UpdateCertificateTemplateInput:{
		orientation:"CertificateOrientation"
	},
	CreateOrganizationInput:{

	},
	UpdateOrganizationInput:{
		status:"OrganizationStatus"
	},
	InviteOrgMemberInput:{
		role:"RoleEnum"
	},
	UpdateReminderSettingsInput:{

	},
	Subscription:{
		basicSubscription:{

		}
	},
	ID: `scalar.ID` as const
}

export const ReturnTypes: Record<string,any> = {
	Permissions:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		roles:"Role"
	},
	DateTime: `scalar.DateTime` as const,
	UserGroupModel:{
		id:"ID",
		name:"String"
	},
	Users:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		status:"AccountStatus",
		email:"String",
		password:"String",
		passwordResetToken:"String",
		passwordResetExpiryDate:"DateTime",
		activateAccountToken:"String",
		activateAccountExpiryDate:"DateTime",
		emailVerified:"Boolean",
		verifyEmailToken:"String",
		verifyEmailExpiryDate:"DateTime",
		firstName:"String",
		lastName:"String",
		refreshToken:"String",
		role:"Role",
		roleId:"String",
		groups:"UserGroupModel",
		progress:"UserProgress"
	},
	UserPagination:{
		users:"Users",
		total:"Int"
	},
	ImportUserError:{
		line:"Int",
		email:"String",
		reason:"String"
	},
	ImportUsersReport:{
		createdCount:"Int",
		errorCount:"Int",
		errors:"ImportUserError"
	},
	Role:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		permissions:"Permissions",
		users:"Users"
	},
	LearnerCountersModel:{
		orgId:"ID",
		orgName:"String",
		orgSlug:"String",
		month:"String",
		monthlyActive:"Int",
		learnerCount:"Int",
		registeredLearners:"Int",
		leavingWithinThreeMonths:"Int",
		subscribedTier:"BillingTier",
		effectiveTier:"BillingTier",
		billedTier:"BillingTier",
		placesRemaining:"Int",
		nextTier:"BillingTier",
		paymentTerm:"BillingPaymentTerm",
		estimatedRevenueCents:"Int"
	},
	BillingAccountModel:{
		id:"ID",
		tier:"BillingTier",
		paymentTerm:"BillingPaymentTerm",
		tierChangedAt:"DateTime",
		companyName:"String",
		addressLine1:"String",
		addressLine2:"String",
		postalCode:"String",
		city:"String",
		country:"String",
		vatNumber:"String",
		billingEmail:"String"
	},
	BillingEstimateModel:{
		month:"String",
		subscribedTier:"BillingTier",
		effectiveTier:"BillingTier",
		billedTier:"BillingTier",
		paymentTerm:"BillingPaymentTerm",
		learnerCount:"Int",
		monthlyActive:"Int",
		registeredLearners:"Int",
		placesRemaining:"Int",
		nextTier:"BillingTier",
		leavingWithinThreeMonths:"Int",
		monthlyPriceCents:"Int",
		monthlyAmountCents:"Int",
		upfrontYearlyAmountCents:"Int",
		isCustom:"Boolean"
	},
	PlanCapabilitiesModel:{
		tier:"BillingTier",
		canCustomizeBranding:"Boolean",
		canUseSso:"Boolean"
	},
	BillingHistoryEntryModel:{
		month:"String",
		monthlyActive:"Int",
		learnerCount:"Int",
		tier:"BillingTier",
		amountCents:"Int"
	},
	AppConfigModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		appName:"String",
		logo:"String",
		favicon:"String",
		primaryColor:"String",
		accentColor:"String",
		headingFont:"String",
		bodyFont:"String",
		footerText:"String",
		defaultLocale:"String",
		timezone:"String",
		brandingLocked:"Boolean",
		signupCtaVisible:"Boolean"
	},
	UniqueAuth:{
		access_token:"String",
		refresh_token:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		email:"String",
		id:"String"
	},
	UserInfo:{
		firstName:"String",
		lastName:"String",
		roles:"RoleEnum",
		email:"String",
		id:"String",
		orgId:"String",
		impersonatorId:"String"
	},
	CertificateTemplateModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		title:"String",
		body:"String",
		signature:"String",
		showScore:"Boolean",
		showDate:"Boolean",
		showTotalTime:"Boolean",
		logo:"String",
		orientation:"CertificateOrientation",
		hasSkeleton:"Boolean",
		marginTop:"Int",
		marginBottom:"Int",
		marginLeft:"Int",
		marginRight:"Int"
	},
	DownloadFile:{
		fileName:"String",
		fileMimeType:"String",
		url:"String"
	},
	MyFiles:{
		id:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		eTag:"String",
		location:"String",
		fileName:"String",
		fileMimeType:"String",
		ownerId:"String"
	},
	UploadPreSignedUrl:{
		url:"String",
		id:"String"
	},
	GroupMemberModel:{
		id:"ID",
		email:"String",
		firstName:"String",
		lastName:"String"
	},
	GroupModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		description:"String",
		memberCount:"Int",
		members:"GroupMemberModel"
	},
	HomeCompletionModel:{
		sessionId:"ID",
		sessionName:"String",
		moduleId:"ID",
		moduleTitle:"String",
		learners:"Int"
	},
	HomeSessionModel:{
		id:"ID",
		name:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		enrolledLearners:"Int",
		pendingLearners:"Int"
	},
	BackOfficeHomeModel:{
		firstName:"String",
		timezone:"String",
		completedToday:"HomeCompletionModel",
		startingSoon:"HomeSessionModel",
		endingSoon:"HomeSessionModel",
		overdue:"HomeSessionModel",
		overdueLearners:"Int",
		overdueSessions:"Int",
		neverStartedLearners:"Int"
	},
	Mail:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		key:"String",
		to:"String",
		data:"String"
	},
	OrganizationModel:{
		id:"ID",
		createdAt:"DateTime",
		name:"String",
		slug:"String",
		status:"OrganizationStatus",
		userCount:"Int"
	},
	OrgMemberModel:{
		id:"ID",
		createdAt:"DateTime",
		email:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		status:"String"
	},
	ReminderSettingsModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		enabled:"Boolean",
		firstDelayDays:"Int",
		frequencyDays:"Int",
		maxReminders:"Int",
		sendHour:"Int",
		subject:"String",
		body:"String"
	},
	ReminderTestResultModel:{
		sent:"Boolean",
		to:"String"
	},
	StorageUsageModel:{
		orgId:"ID",
		orgName:"String",
		orgSlug:"String",
		usedBytes:"Float",
		quotaBytes:"Float",
		remainingBytes:"Float",
		plan:"BillingTier",
		moduleCount:"Int",
		overQuota:"Boolean"
	},
	ScormModuleModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		title:"String",
		description:"String",
		scormVersion:"String",
		launchUrl:"String",
		status:"ScormModuleStatus",
		sizeBytes:"Float"
	},
	ScormTrackingModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		sessionTime:"String",
		suspendData:"String",
		location:"String",
		completedAt:"DateTime",
		userId:"String",
		sessionId:"String"
	},
	ScormTrackingWithUser:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		sessionTime:"String",
		suspendData:"String",
		location:"String",
		completedAt:"DateTime",
		userId:"String",
		userEmail:"String",
		userFirstName:"String",
		userLastName:"String",
		sessionId:"String",
		sessionName:"String"
	},
	ScormTrackingStats:{
		total:"Int",
		completed:"Int",
		inProgress:"Int",
		notStarted:"Int",
		completionUnknown:"Int",
		neverOpened:"Int",
		notYetUnlocked:"Int",
		passed:"Int",
		failed:"Int",
		averageScorePercent:"Float",
		scoredCount:"Int",
		averageTimeSeconds:"Int",
		timedCount:"Int"
	},
	ScormTrackingPagination:{
		trackings:"ScormTrackingWithUser",
		total:"Int"
	},
	SessionUserModel:{
		id:"ID",
		email:"String",
		firstName:"String",
		lastName:"String"
	},
	SessionModuleModel:{
		id:"ID",
		position:"Int",
		unlockAt:"DateTime",
		module:"ScormModuleModel",
		unlocked:"Boolean",
		lockReason:"ModuleLockReason",
		myTracking:"ScormTrackingModel"
	},
	SessionProgressModel:{
		totalModules:"Int",
		completedModules:"Int",
		completed:"Boolean"
	},
	SessionModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		startDate:"DateTime",
		endDate:"DateTime",
		status:"SessionStatus",
		progressionMode:"SessionProgressionMode",
		module:"ScormModuleModel",
		modules:"SessionModuleModel",
		enrolledUsers:"SessionUserModel",
		myTracking:"ScormTrackingModel",
		progress:"SessionProgressModel"
	},
	RequestTrialResult:{
		accepted:"Boolean"
	},
	ConfirmTrialResult:{
		status:"TrialReviewStatus",
		email:"String",
		slug:"String",
		rejectionReason:"String"
	},
	TrialRequestModel:{
		id:"ID",
		email:"String",
		firstName:"String",
		lastName:"String",
		orgName:"String",
		jobTitle:"String",
		phone:"String",
		createdAt:"DateTime",
		emailConfirmedAt:"DateTime"
	},
	ApproveTrialResult:{
		slug:"String"
	},
	SsoOrgSettingsModel:{
		enabled:"Boolean"
	},
	SsoPresetModel:{
		kind:"SsoProviderKind",
		protocol:"String",
		defaultLabel:"String",
		defaultIssuer:"String",
		issuerHint:"String",
		sharedIssuer:"Boolean"
	},
	SsoProviderModel:{
		id:"ID",
		kind:"SsoProviderKind",
		protocol:"String",
		label:"String",
		enabled:"Boolean",
		issuer:"String",
		clientId:"String",
		hasClientSecret:"Boolean",
		entryPoint:"String",
		idpIssuer:"String",
		idpCert:"String",
		allowedDomains:"String",
		requiresAllowedDomains:"Boolean",
		callbackUrl:"String",
		metadataUrl:"String"
	},
	PublicSsoProviderModel:{
		id:"ID",
		kind:"SsoProviderKind",
		label:"String",
		loginUrl:"String"
	},
	Health:{
		env:"String",
		time:"String",
		status:"String",
		version:"String"
	},
	StatsNotice:{
		status:"ConsentStatus",
		acknowledgedAt:"DateTime",
		version:"String",
		currentVersion:"String",
		needsAcknowledgement:"Boolean"
	},
	Query:{
		getHealthGql:"Health",
		getRole:"Role",
		getRoles:"Role",
		getPermission:"Permissions",
		getPermissions:"Permissions",
		getMail:"Mail",
		getMails:"Mail",
		appConfig:"AppConfigModel",
		learnerCounters:"LearnerCountersModel",
		learnerCountersByOrganization:"LearnerCountersModel",
		billingAccount:"BillingAccountModel",
		planCapabilities:"PlanCapabilitiesModel",
		billingEstimate:"BillingEstimateModel",
		billingHistory:"BillingHistoryEntryModel",
		me:"UserInfo",
		getUser:"Users",
		getUsers:"Users",
		getExistingUserEmails:"String",
		getFilteredUsers:"UserPagination",
		groups:"GroupModel",
		group:"GroupModel",
		ssoProviders:"PublicSsoProviderModel",
		ssoSettings:"SsoOrgSettingsModel",
		ssoPresets:"SsoPresetModel",
		ssoProviderConfigs:"SsoProviderModel",
		scormModules:"ScormModuleModel",
		scormModule:"ScormModuleModel",
		storageUsage:"StorageUsageModel",
		storageUsageByOrganization:"StorageUsageModel",
		getMyScormTracking:"ScormTrackingModel",
		getScormTrackings:"ScormTrackingPagination",
		getScormTrackingStats:"ScormTrackingStats",
		sessions:"SessionModel",
		session:"SessionModel",
		userSessions:"SessionModel",
		mySessions:"SessionModel",
		pendingTrialRequests:"TrialRequestModel",
		backOfficeHome:"BackOfficeHomeModel",
		certificateTemplate:"CertificateTemplateModel",
		downloadFile:"DownloadFile",
		getAllMyFiles:"MyFiles",
		publishBasicSubscription:"Boolean",
		myStatsNotice:"StatsNotice",
		organizations:"OrganizationModel",
		organizationMembers:"OrgMemberModel",
		reminderSettings:"ReminderSettingsModel"
	},
	Mutation:{
		updateAppConfig:"AppConfigModel",
		updateBillingProfile:"BillingAccountModel",
		changeBillingPlan:"BillingAccountModel",
		login:"AuthType",
		requestMagicLink:"Boolean",
		loginWithMagicLink:"AuthType",
		askForResetPassword:"Boolean",
		reSendEmailValidation:"Boolean",
		resetPassword:"Boolean",
		verifyEmail:"Boolean",
		finishRegister:"Boolean",
		refresh:"AuthType",
		logout:"Boolean",
		uniqueAuthFromSso:"UniqueAuth",
		impersonateUser:"AuthType",
		stopImpersonate:"AuthType",
		createUser:"Users",
		importUsers:"ImportUsersReport",
		updateUser:"Users",
		deleteUser:"Boolean",
		createGroup:"GroupModel",
		updateGroup:"GroupModel",
		deleteGroup:"Boolean",
		addUsersToGroup:"Int",
		removeUsersFromGroup:"Int",
		setSsoEnabled:"SsoOrgSettingsModel",
		upsertSsoProvider:"SsoProviderModel",
		deleteSsoProvider:"Boolean",
		deleteScormModule:"Boolean",
		upsertScormTracking:"ScormTrackingModel",
		createSession:"SessionModel",
		updateSession:"SessionModel",
		deleteSession:"Boolean",
		requestTrialOrganization:"RequestTrialResult",
		confirmTrialOrganization:"ConfirmTrialResult",
		approveTrialRequest:"ApproveTrialResult",
		rejectTrialRequest:"Boolean",
		updateCertificateTemplate:"CertificateTemplateModel",
		deleteFile:"Boolean",
		uploadPreSignedUrl:"UploadPreSignedUrl",
		confirmUpload:"Boolean",
		acknowledgeStatsNotice:"StatsNotice",
		createOrganization:"OrganizationModel",
		setOrganizationStatus:"OrganizationModel",
		updateOrganization:"OrganizationModel",
		deleteOrganization:"Boolean",
		inviteOrgMember:"OrgMemberModel",
		removeOrgMember:"Boolean",
		updateReminderSettings:"ReminderSettingsModel",
		sendReminderTest:"ReminderTestResultModel"
	},
	AuthType:{
		"...on UserInfo":"UserInfo",
		"...on CustomError":"CustomError"
	},
	CustomError:{
		error:"EError",
		message:"String"
	},
	Subscription:{
		basicSubscription:"String"
	},
	ID: `scalar.ID` as const
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const,
	subscription: "Subscription" as const
}